import { View, Text } from "react-native";
import React from "react";
import { gray } from "../../colors";
import MyText from "../custom/MyText";

export default function TestTitle({ title }) {
  return (
    <View
      style={{
        width: "98%",
        alignItems: "center",

        padding: 5,
        borderRadius: 10,
        marginVertical: 5,
        flexDirection: "row",
      }}
    >
      <View style={{ flex: 1, height: 2, backgroundColor: "#ddd" }}></View>
      <View style={{ width: 15 }}></View>
      <MyText
        fontFamily={"vazir"}
        style={{ fontSize: 20, color: gray }}
      >{`${title}`}</MyText>
      <View style={{ width: 15 }}></View>
      <View style={{ flex: 1, height: 2, backgroundColor: "#ddd" }}></View>
    </View>
  );
}
